(function () {
  var STORAGE_KEY = 'psm_ship_prefecture';
  var dataEl = document.getElementById('psm-shipping-rates');
  if (!dataEl) return;

  var data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var prefectures = Object.keys(data.prefectures);
  var yen = function (n) {
    return '¥' + Number(n).toLocaleString('ja-JP');
  };

  function getSaved() {
    try {
      return localStorage.getItem(STORAGE_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function save(pref) {
    try {
      if (pref) localStorage.setItem(STORAGE_KEY, pref);
    } catch (e) {}
  }

  function fillOptions(select) {
    if (select.options.length > 1) return;
    prefectures.forEach(function (p) {
      var opt = document.createElement('option');
      opt.value = p;
      opt.textContent = p;
      select.appendChild(opt);
    });
  }

  // ---------- 商品ページ：料金表から計算 ----------

  // 「Set-3」「Cランク」「2名配送 Bランク」「Sサイズ / Mサイズ | Cランク ⏎ Lサイズ | Eランク」などから料金表のキーを取り出す
  function parseRankKeys(text) {
    var keys = [];
    (text || '').split(/\r?\n/).forEach(function (line) {
      var norm = line.replace(/\s+/g, '');
      if (/^\*/.test(norm)) return;
      var two = norm.match(/2名配送([A-Z])ランク/);
      var set = norm.match(/Set-(\d)/i);
      var rank = norm.match(/([A-Z])ランク/);
      var key = null;
      if (two) key = '2名配送 ' + two[1];
      else if (set) key = 'Set-' + set[1];
      else if (/小物/.test(norm)) key = '小物';
      else if (rank) key = rank[1];
      if (key && data.rates[key] && keys.indexOf(key) === -1) keys.push(key);
    });
    return keys;
  }

  function range(values) {
    var min = Math.min.apply(null, values);
    var max = Math.max.apply(null, values);
    return min === max ? yen(min) : yen(min) + '〜' + yen(max);
  }

  function renderCompact(w, pref) {
    var keys = w._psmKeys;
    var feeEl = w.querySelector('[data-psm-ship-fee]');
    if (keys.length !== 1) {
      feeEl.textContent = 'サイズにより異なります';
      return;
    }
    var rates = data.rates[keys[0]];
    var idx = data.prefectures[pref];
    feeEl.textContent =
      idx === undefined ? yen(Math.min.apply(null, rates)) + '〜' : yen(rates[idx]) + '（' + pref + '）';
  }

  function renderProduct(w, pref) {
    if (w.hasAttribute('data-psm-compact')) {
      renderCompact(w, pref);
      return;
    }
    var keys = w._psmKeys;
    var feeEl = w.querySelector('[data-psm-ship-fee]');
    var select = w.querySelector('[data-psm-ship-select]');
    if (select.value !== pref) select.value = pref;

    if (!keys.length) {
      select.hidden = true;
      feeEl.textContent = 'サイズ・仕様により異なります';
      return;
    }

    var idx = data.prefectures[pref];
    var suffix = keys.length > 1 ? '（サイズにより異なります）' : '';
    if (idx === undefined) {
      var all = [];
      keys.forEach(function (k) {
        all = all.concat(data.rates[k]);
      });
      feeEl.textContent = range(all) + '（税込）' + suffix;
    } else {
      var values = keys.map(function (k) {
        return data.rates[k][idx];
      });
      var region = data.regions[idx] === pref.replace(/県$/, '') ? '' : '・' + data.regions[idx];
      feeEl.textContent = range(values) + '（税込' + region + '）' + suffix;
    }
  }

  function initProduct(w) {
    w._psmInit = true;
    w._psmKeys = parseRankKeys(w.getAttribute('data-delivery'));
    if (w.hasAttribute('data-psm-compact')) {
      renderCompact(w, getSaved());
      return;
    }
    var select = w.querySelector('[data-psm-ship-select]');
    fillOptions(select);
    select.addEventListener('change', function () {
      setPrefecture(select.value);
    });

    var note = w.querySelector('[data-psm-ship-note]');
    var isSmall = w._psmKeys.length === 1 && w._psmKeys[0] === '小物';
    var text = isSmall ? '' : '商品1点ごとの送料です。';
    if (w.getAttribute('data-small-free') === 'true') text = '合計15,000円（税別）以上で送料無料。' + text;
    note.insertAdjacentText('afterbegin', text);

    renderProduct(w, getSaved());
  }

  // ---------- カート：Shopify の送料計算（決済時と同じ）に問い合わせ ----------

  var cartRequestId = 0;

  function renderCart(w, pref) {
    var feeEl = w.querySelector('[data-psm-ship-fee]');
    var select = w.querySelector('[data-psm-ship-select]');
    if (select.value !== pref) select.value = pref;

    var addr = data.addresses && data.addresses[pref];
    if (!addr) {
      feeEl.textContent = '都道府県を選ぶと送料合計を表示します';
      return;
    }

    var requestId = ++cartRequestId;
    feeEl.textContent = '計算中…';
    var params = new URLSearchParams({
      'shipping_address[country]': 'Japan',
      'shipping_address[province]': addr[0],
      'shipping_address[zip]': addr[1]
    });

    fetch('/cart/shipping_rates.json?' + params.toString(), { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.ok ? res.json() : Promise.reject(res.status);
      })
      .then(function (json) {
        if (requestId !== cartRequestId) return;
        var rates = (json && json.shipping_rates) || [];
        if (!rates.length) throw new Error('no rates');
        var prices = rates.map(function (r) {
          return Number(r.price);
        });
        feeEl.textContent = range(prices) + '（税込）';
      })
      .catch(function () {
        if (requestId !== cartRequestId) return;
        feeEl.textContent = 'ご購入手続き画面でご確認ください';
      });
  }

  function initCart(w) {
    w._psmInit = true;
    var select = w.querySelector('[data-psm-ship-select]');
    fillOptions(select);
    select.addEventListener('change', function () {
      setPrefecture(select.value);
    });
    renderCart(w, getSaved());
  }

  // ---------- 共通 ----------

  function setPrefecture(pref) {
    save(pref);
    document.querySelectorAll('[data-psm-ship]').forEach(function (w) {
      renderProduct(w, pref);
    });
    document.querySelectorAll('[data-psm-cart-ship]').forEach(function (w) {
      renderCart(w, pref);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-psm-ship]').forEach(function (w) {
      if (!w._psmInit) initProduct(w);
    });
    document.querySelectorAll('[data-psm-cart-ship]').forEach(function (w) {
      if (!w._psmInit) initCart(w);
    });
  }

  // 「組立設置」などのオプションで都道府県を選んだら、送料表示も同じ都道府県に合わせる
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || el.tagName !== 'SELECT' || el.hasAttribute('data-psm-ship-select')) return;
    var text = el.options[el.selectedIndex] ? el.options[el.selectedIndex].text : '';
    var match = prefectures.filter(function (p) {
      return text.indexOf(p) !== -1 || el.value.indexOf(p) !== -1;
    })[0];
    if (match) setPrefecture(match);
  });

  initAll();

  // カートは数量変更などでセクションごと描き直されるので、新しく入った表示を初期化し、送料を取り直す
  var timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(function () {
      initAll();
    }, 100);
  }).observe(document.body, { childList: true, subtree: true });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(function () {
        document.querySelectorAll('[data-psm-cart-ship]').forEach(function (w) {
          renderCart(w, getSaved());
        });
      }, 300);
    });
  }
})();
